import { competitionStatus } from './competitionStatus'

export const competitionTypes = {
  APPLICATION: 'APPLICATION',
  CREDIT: 'CREDIT',
  GUARANTEE: 'GUARANTEE',
  CAPITAL_PRODUCT: 'CAPITAL_PRODUCT',
  COMBINED: 'COMBINED'
}

export const getReadableCompetitionType = id => {
  switch (id) {
    case competitionTypes.APPLICATION:
      return 'Támogatás'
    case competitionTypes.CREDIT:
      return 'Hiteltermék'
    case competitionTypes.GUARANTEE:
      return 'Garanciatermék'
    case competitionTypes.CAPITAL_PRODUCT:
      return 'Tőketermék'
    case competitionTypes.COMBINED:
      return 'Kombinált termék'
  }
}

export const allCompetitionTypes = [
  competitionStatus.DRAFT,
  competitionStatus.UNDER_APPROVAL,
  competitionStatus.APPROVED,
  competitionStatus.ACTIVE,
  competitionStatus.INACTIVE
]

export const draftCompetitionTypes = [competitionStatus.DRAFT]

export const activeCompetitionTypes = [competitionStatus.ACTIVE]
